import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    imports: [RouterModule]
})
export class UserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
